<template>
  <v-menu offset-x>
    <template v-slot:activator="{ attrs, on }">
      <v-btn v-bind="attrs" v-on="on" icon>
        <v-progress-circular v-if="comContactsState.loading" indeterminate color="primary" size="24" width="3"/>
        <v-avatar v-else-if="comContactsState.success && comContact!==null" size="26" :color="comContact.info.messengerTypeIconBgColor">
          <v-icon size="14" color="white">{{comContact.info.messengerTypeIcon}}</v-icon>
        </v-avatar>
      </v-btn>
    </template>
    <div class="body-2">
      <div class="caption px-4 py-2">Отправить через</div>
      <v-list dense>
        <v-list-item
            v-for="(v,k) in comContactsState.data.items" :key="k"
            @click="comContact=v;"
            :class="comContact===null ? '' : comContact.id===v.id ? 'v-list-item--active' : ''"
            dense
        >
          <v-row no-gutters>
            <v-col cols="auto" class="pr-2">
              <v-avatar size="22" :color="v.info.messengerTypeIconBgColor">
                <v-icon size="12" color="white">{{v.info.messengerTypeIcon}}</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="auto" class="pr-2">
              {{$tools.isEmpty(v.name) ? '(Без названия)' : v.name}}
            </v-col>
            <v-col cols="auto">
              {{$tools.phoneFormat(v.phone)}}
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
import {Entity_ComContact} from "../../../../../EntityStoreCacheService";
import Stater from "../../../../plugins/stater";

export default {
  props:['comContactSelected','chat'],
  data:()=>({
    comContactsState:new Stater({items:[],count:0}),
    comContact:null,
    comContactRequested:null,
  }),
  watch:{
    comContact(){
      this.$emit('update:comContactSelected', this.comContact)
    }
  },
  mounted(){
    this.load();
  },
  methods:{
    load(callback=null){
      new Entity_ComContact()
          .selects(Entity_ComContact.id)
          .selects(Entity_ComContact.sid)
          .selects(Entity_ComContact.name)
          .selects(Entity_ComContact.phone)
          .selects(Entity_ComContact.messengerType)
          .selects(Entity_ComContact.compareCode)
          .order(Entity_ComContact.phone, true)
          .virtual(Entity_ComContact.virtual_info)
          .virtual(Entity_ComContact.virtual_allowSend, this.chat?.id)
          .page(1)
          .onPage(100)
          .addStateCallback((v)=>{
            if(v.success){
              v.items.unshift({
                id:null,
                name:'Внутренний',
                info:{
                  messengerTypeIcon: 'mdi-message-text',
                  messengerTypeIconBgColor: 'blue',
                  messengerTypeStr: 'Внутренний'
                }
              });
              this.comContact = v.items[0];
              this.comContactRequestUpdate();
              if(callback!==null)
                callback();
            }
            this.comContactsState.setRequestBuilderState(v)
          })
          .request()
    },
    comContactRequest(v, reload=false){
      let d = ()=>{
        this.comContactRequested = v;
        this.comContactRequestUpdate();
      };
      if(reload) this.load(d);
      else d();
    },
    comContactRequestUpdate(){
      this.$nextTick(()=>{
        if(this.comContactRequested===null){
          this.comContact = this.comContactsState.data.items[0];
        } else {
          this.comContactsState.data.items
              .filter(v1=>v1.id===this.comContactRequested?.id)
              .forEach(v1=>{
                this.comContact = v1;
              })
        }
      })
    }
  }
}
</script>